<template>
    <a-locale-provider :locale="locale">
        <div id="app">
            <router-view />
        </div>
    </a-locale-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { AppDeviceEnquire } from '@/utils/mixin'

export default {
    mixins: [AppDeviceEnquire],
    data() {
        return {
            locale: zhCN
        }
    },
    mounted() {}
}
</script>
<style lang="less">
#app {
    height: 100%;
}
.btnCon {
    position: relative;
    overflow: hidden;
    display: inline-block;
    input {
        display: block;
        position: absolute;
        z-index: 1;
        width: 100%;
        height: 100%;
        background: red;
        opacity: 0;
    }
}
.editCon {
    margin-bottom: 20px;
    position: relative;
    .editCon {
        position: absolute;
        z-index: 1;
        top: 3px;
        right: 5px;
    }
}
</style>
